import Cookies from "js-cookie";

export default function isTokenValid() {
  const token = Cookies.get(process.env.VUE_APP_TOKEN_KEY);
  if (token === null || token === "" || token === undefined) {
    return false
  }
  return true;
}
